module.exports = __webpack_public_path__ + "img/05平面圖.63f15a91.jpg";